import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  SxProps,
  useTheme,
} from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IMonitoring } from '../../shared/interfaces/IMonitoring';

interface Props {
  value: string[];
  monitorings: IMonitoring[];
  onChange: (event: SelectChangeEvent<string[]>) => void;
  sx?: SxProps;
}

const MonitoringMultiSelect: FC<Props> = ({ value, monitorings, onChange }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <FormControl
      size="small"
      sx={{ minWidth: '284px', maxWidth: '284px', my: theme.spacing(1) }}
    >
      <InputLabel id="monitoring-select-label">{t('monitoring')}</InputLabel>
      <Select
        labelId="monitoring-select-label"
        multiple
        value={value}
        input={<OutlinedInput label={t('monitoring')} />}
        onChange={onChange}
        label={t('monitoring')}
      >
        {monitorings &&
          monitorings.map(({ id, label }, index) => {
            return (
              <MenuItem
                value={id}
                key={index}
                sx={{
                  fontWeight: value.includes(id) ? 700 : 400,
                }}
              >
                {label}
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
  );
};

export default MonitoringMultiSelect;
